export var Symbols  = 'symbol';
export var Discrete = 'discrete';
export var Gradient = 'gradient';
